module.exports = __webpack_public_path__ + "static/media/step_3.f5d0a753.png";